import { render, staticRenderFns } from "./blok-date.vue?vue&type=template&id=38900648&scoped=true"
import script from "./blok-date.vue?vue&type=script&lang=js"
export * from "./blok-date.vue?vue&type=script&lang=js"
import style0 from "./blok-date.vue?vue&type=style&index=0&id=38900648&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38900648",
  null
  
)

export default component.exports